import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { styled } from '@mui/material/styles'
import {
  Tabs,
  Tab,
  IconButton
} from '@mui/material'
import SettingsIcon from '@mui/icons-material/Settings'
import BoardModal from './modal/BoardModal'
import Table from '@views/adminBoard/table/Table'

import {
  adminGetBoardList,
} from '@store/admin/board'

const StyledTabs = styled(Tabs)({
  marginBottom: 20,
  '& .MuiTabs-indicator': {
    backgroundColor: '#000'
  }
})

const StyledTab = styled(Tab)({
  '&.Mui-selected': {
    color: '#000',
    fontWeight: 'bold'
  }
})

const AdminEmployee = () => {
  const dispatch = useDispatch()
  const {
    boardList,
    boards,
  } = useSelector(store => store.boardAdmin)
  const [ boardId, setBoardId ] = useState(0)
  const [ modalOpen, setModalOpen ] = useState(false)

  const handleChange = (event, newValue) => {
    setBoardId(newValue)
  }

  const onOpenBoardModal = () => {
    setModalOpen(true)
  }

  const onCloseBoardModal = () => {
    setModalOpen(false)
  }


  const onGetBoardList = useCallback(() => {
    dispatch(adminGetBoardList())
  }, [dispatch])

  useEffect(() => onGetBoardList(), [onGetBoardList])

  useEffect(() => {
    if (!boardId && boardList.length) {
      setBoardId(boardList[0])
    }
  }, [boardId, boardList])

  return (
    <div>
      <h2>
        게시판 관리
        <IconButton onClick={onOpenBoardModal} sx={{pt: .3}}>
          <SettingsIcon />
        </IconButton>
      </h2>

      {
        !!boardId && <>
          <StyledTabs
            value={boardId}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs"
          >
            {
              boardList.map((boardId, index) => {
                const {name} = boards[boardId]
                return (
                  <StyledTab label={name} key={index} value={boardId} />
                )
              })
            }
          </StyledTabs>
          <Table 
            boardId={boardId}
          />
        </>
      }

      {
        modalOpen && <BoardModal 
          open={modalOpen}
          list={boardList}
          lists={boards}
          onGetBoardList={onGetBoardList}
          closeModal={onCloseBoardModal}
        />
      }
    </div>
  )
}

export default AdminEmployee